import { On3IconNoAdsIcon } from '@on3/icons';
import { useAuth } from '@on3/ui-lib/index';
import Link from 'next/link';

import { PerkChecklistItem } from '../PerkChecklist/Item/PerkChecklistItem';
import styles from './MembersHeader.module.scss';

export const MembersHeader = () => {
  const { user } = useAuth();
  const hasPremiumAccess = user?.st.includes('premium');

  return (
    <div className={styles.block}>
      <header>
        <h1>Thank you for being a member!</h1>
        {!hasPremiumAccess && <span>Upgrade to ad-free</span>}
      </header>

      {!hasPremiumAccess && (
        <>
          <div className={styles.container}>
            <On3IconNoAdsIcon />
            <ul>
              <PerkChecklistItem label="Ad-free experience" />
              <PerkChecklistItem label="Only pay the upgrade difference" />
              <PerkChecklistItem label="Super fast page loads" />
            </ul>
          </div>

          <Link href="/my/settings/">Turn Off Ads Now</Link>
        </>
      )}
    </div>
  );
};
